export function enableGetResponse() {
  (function (m, o, n, t, e, r, _) {
    m["__GetResponseAnalyticsObject"] = e;
    m[e] =
      m[e] ||
      function () {
        (m[e].q = m[e].q || []).push(arguments);
      };
    r = o.createElement(n);
    _ = o.getElementsByTagName(n)[0];
    r.async = 1;
    r.src = t;
    r.setAttribute("crossorigin", "use-credentials");
    _.parentNode.insertBefore(r, _);
  })(window, document, "script", `https://an.gr-wcon.com/script/${window.__GR_ID__}/ga.js`, "GrTracking");
}
